import { TOGGLE_SIDEBAR, SET_SIDEBAR_STIMULUS_IS_SHOWING } from '@instructure/quiz-common';
export function toggleSidebar() {
  return {
    type: TOGGLE_SIDEBAR
  };
}
export function setSidebarStimulusIsShowing(stimulusId, bool) {
  return {
    type: SET_SIDEBAR_STIMULUS_IS_SHOWING,
    payload: {
      stimulusId: stimulusId,
      bool: bool
    }
  };
}